import { NotificationPreferencesCard } from "@khazzin/ui/patterns";
import { useApi } from "../../api";
import { useLocale } from "../../app/shell/locale";
import { useStoreScope } from "../../app/shell/scope";

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * `/notifications` (EP10-S12, CR-025): every account's own notification
 * preferences — category × channel and quiet hours over the store's defaults
 * — whatever its grid. A sub-account without the Settings section reaches
 * them here; the store's defaults stay on Settings.
 */
export function MyNotificationsPage() {
	const { t } = useLocale();
	const { store } = useStoreScope();
	const api = useApi();
	return (
		<section aria-labelledby="notifications-title" className="flex flex-col gap-4">
			<h1 id="notifications-title" className="text-[18px] font-bold text-fg">
				{t("portal.settings.notifications.mine")}
			</h1>
			<NotificationPreferencesCard
				api={api}
				t={t}
				title={t("portal.settings.notifications.mine")}
				subtitle={t("portal.settings.notifications.mineHint")}
				{...(store === null ? {} : { storeId: store.storeId })}
				defaultTimezone={timeZone}
			/>
		</section>
	);
}
